import React, { createContext, useContext, useState, useEffect } from 'react';

const MonthContext = createContext();

export const useMonth = () => {
  const context = useContext(MonthContext);
  if (!context) {
    throw new Error('useMonth must be used within MonthProvider');
  }
  return context;
};

export const MonthProvider = ({ children }) => {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });

  // Generate list of months (last 24 months + next 2 months)
  const getMonthOptions = () => {
    const options = [];
    const now = new Date();
    
    // Start from 24 months ago
    for (let i = -24; i <= 2; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() + i, 1);
      const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const label = date.toLocaleString('default', { month: 'short', year: 'numeric' });
      options.push({ value, label });
    }
    
    return options.reverse();
  };

  const monthOptions = getMonthOptions();
  
  const getMonthLabel = (monthValue) => {
    if (!monthValue) return '';
    const [year, month] = monthValue.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1, 1);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  return (
    <MonthContext.Provider value={{
      selectedMonth,
      setSelectedMonth,
      monthOptions,
      monthLabel: getMonthLabel(selectedMonth),
      getMonthLabel
    }}>
      {children}
    </MonthContext.Provider>
  );
};

export default MonthProvider;
